import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {getToken,setToken} from "./utils/auth";
import cookie from 'js-cookie'
import 'mint-ui/lib/style.css';
import { MessageBox,Toast,InfiniteScroll  } from 'mint-ui';
Vue.use(InfiniteScroll)
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$toast  = Toast ;
import './assets/font/iconfont.css'
// import './assets/font/01/iconfont.css'
import {wxloginUrl} from "./utils/wxLoginUrl";


router.beforeEach((to, from, next) => {

    if (to.meta.title) {
        document.title = to.meta.title
    }

    if (to.query.token!=undefined) {
        setToken(to.query.token);
        router.push({
            path:'/'
        });
        // location.href = '/m';
        return false;
        // next();
    }

    if (process.env.NODE_ENV != 'development') {

        if (!getToken()) {
            location.href=wxloginUrl;
            return false;
        } else {
            next();
        }

    }


        next();

});




Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
